import {TypographySize, useTypography} from '@time-webkit/all/hooks';
import classNames from 'classnames';
import {type ChangeEvent, useState} from 'react';

import {useIntl} from 'react-intl';

import {useMaskito} from '@maskito/react';

import styles from './styles.module.css';
import type {TimeChipProps} from './time-chip';
import {convertTime, maskitoOptions} from './mask';

type Props = {
    showTime: boolean;
} & TimeChipProps;

export const TimeChipInput = ({showTime, onChange, value, label}: Props) => {
    const [displayTimeValue, setDisplayTimeValue] = useState('');

    const typography = useTypography({size: TypographySize.BodyMTrue});

    const maskedInputRef = useMaskito({options: maskitoOptions});

    const {formatMessage} = useIntl();

    const hoursText = formatMessage({
        id: 'time-chip.hours',
        defaultMessage: 'h',
    });
    const minutesText = formatMessage({
        id: 'time-chip.minutes',
        defaultMessage: 'min',
    });
    const labelText = formatMessage({
        id: 'time-chip.label',
        defaultMessage: 'hh:mm',
    });

    const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);

        const convertedTime = convertTime({hoursText, minutesText, time: e.target.value});

        setDisplayTimeValue(convertedTime);
    };

    if (showTime) {
        return (
            <span className={classNames(styles.timeText, typography)}>
                {displayTimeValue}
            </span>
        );
    }

    return (
        <input
            className={classNames(styles.input, typography)}
            value={value}
            ref={maskedInputRef}
            onInput={handleInput}
            placeholder={label ?? labelText}
        />
    );
};
